import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  DriverLastPlaceResponseDTO
} from '../../interfaces/apiInterfaces';

export class GetOwnerDriverLastPlaceCommand extends IRequestCommand<
  Array<IGetOwnerDriverLastPlace>,
  ErrorDetails,
  IGetOwnerDriverLastPlaceCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/owner/{ownerId}/lastPlace?state={state}';

  public override setParameters(parameters: IGetOwnerDriverLastPlaceCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{ownerId}',
      parameters.ownerId.toString()
    );
    this._commandUrl = this.commandUrl.replace(
      '{state}',
      parameters.state.toString()
    )
  }
}

export interface IGetOwnerDriverLastPlaceCommandParameters
  extends ICommandParameters {
  carrierUserId: string;
  ownerId: string;
  state: string
}

export interface IGetOwnerDriverLastPlace
  extends ICommandResponse,
  DriverLastPlaceResponseDTO { }
